export default __webpack_public_path__ + "static/media/leak.c3cf6975.svg";